import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=2bd8a52e&scoped=true&"
import script from "./UserGroup.vue?vue&type=script&lang=js&"
export * from "./UserGroup.vue?vue&type=script&lang=js&"
import style0 from "./UserGroup.vue?vue&type=style&index=0&id=2bd8a52e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8a52e",
  null
  
)

export default component.exports